<script setup>
import { computed, onMounted, ref } from 'vue';
import axios from 'axios';
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
import { useForm,Link, usePage } from '@inertiajs/vue3';

// const props = defineProps({
//     services: {
//         type: Array,
//         required: true,
//     },
// });



const page = usePage()

const services = ref([]);

async function getServices() {
    try {
        const res = await axios.get('/services-data');
        services.value = res.data || []; // Assign response data or keep empty object
    } catch (error) {
        console.error('Error fetching hero text:', error);
    }
}

onMounted(() => {
    getServices();
})

const form = useForm({
    service_slug: "",
})

const getSlug = computed(()=>{
    return form.service_slug
})

</script>
<template>
    <section class="text-gray-600 body-font">
        <div class="container pt-16 pb-4 mx-auto">
            <div class="flex flex-wrap xl:pt-20 sm:pt-12 pt-6 wow animate__animated animate__fadeInLeft">
                <div class="lg:w-1/2 mx-auto px-4">
                    <h1
                        class="text-gray-900 xl:text-[48px] lg:text-[38px] text-2xl font-medium title-font xl:mb-5 sm:mb-2 mb-1">
                        {{ $t('booking.title') }}</h1>
                    <p class="xl:text-lg text-base text-gray-500 xl:mb-10 sm:mb-4 mb-2">{{ $t('booking.sub_title') }}
                        <span class="text-primary">helpcenter@nochinta.xyz</span>
                    </p>
                    <div class="rounded-lg mb-4">
                        <label for="location" class="text-xl font-medium text-black">{{ $t('booking.select_service')
                            }}</label>
                        <select id="location" v-model="form.service_slug"
                            class="w-full border text-lg border-gray-300 bg-[#c5e8eb] bg-opacity-[0.3]  hover:border-gray-600 focus:border-primary rounded focus:ring-0 leading-relaxed outline-none text-gray-800 py-2 mt-1 transition-colors duration-200 ease-in-out" required>
                            <option value="">{{ $t('common.choose_one') }}</option>
                            <option :value="service?.slug" v-for="service in services" :key="service.id">{{ locale
                            === 'BN' ? service?.bn_title : service?.title}}</option>
                        </select>
                    </div>
                    <Link :href="route('service.page', getSlug)"
                        class="mt-4 flex w-full text-center justify-center items-center text-white bg-primary border-0 py-2 px-8 focus:outline-none hover:bg-[#1565C0] transition duration-300 rounded xl:text-lg text-base uppercase">{{
                        $t('booking.button') }}</Link>
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped></style>
